"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestClient = void 0;
const utils_1 = require("@streamr/utils");
const makeHttpRequest_1 = require("./makeHttpRequest");
const logger = new utils_1.Logger(module);
class RestClient {
    baseUrl;
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    // TODO: can be removed. 
    // If the client creates the session we don't need to explicitly create a sessionId on the server side.
    // The server can run challanges based on a sessionId generated in each request.
    async createSession() {
        const url = this.baseUrl + '/sessions';
        try {
            const response = await (0, makeHttpRequest_1.makeHttpRequest)('POST', url, {});
            return response.id;
        }
        catch (err) {
            logger.debug(err);
            throw err;
        }
    }
    async createSubdomainAndCertificate(streamrWebSocketPort, sessionId) {
        const url = this.baseUrl + '/certificates';
        const body = {
            streamrWebSocketPort,
            sessionId
        };
        return await (0, makeHttpRequest_1.makeHttpRequest)('PATCH', url, body, 2 * 60 * 1000);
    }
    async updateCertificate(subdomain, streamrWebSocketPort, sessionId, token) {
        const url = this.baseUrl + '/certificates/' + encodeURIComponent(subdomain);
        const body = {
            token,
            sessionId,
            streamrWebSocketPort
        };
        return await (0, makeHttpRequest_1.makeHttpRequest)('PATCH', url, body);
    }
    async updateSubdomainIp(subdomain, streamrWebSocketPort, sessionId, token) {
        logger.debug('updateSubdomainIp() subdomain: ' + subdomain + ', streamrWebSocketPort:  ' + streamrWebSocketPort
            + ', sessionId: ' + sessionId + ', token: ' + token);
        const url = this.baseUrl + '/certificates/' + encodeURIComponent(subdomain) + '/ip';
        const body = {
            token,
            sessionId,
            streamrWebSocketPort
        };
        await (0, makeHttpRequest_1.makeHttpRequest)('PUT', url, body);
    }
}
exports.RestClient = RestClient;
//# sourceMappingURL=RestClient.js.map